export default __webpack_public_path__ + "static/media/bg-detail-bottom.0503c852.svg";